import { AlertTriangle } from 'lucide-react';
import { useMarkRead, useNotifications } from '@/lib/notifications';

export interface RLPNotificationBannerProps {
  rlpId: string;
}

export function RLPNotificationBanner({ rlpId }: RLPNotificationBannerProps) {
  const { data } = useNotifications({
    entityType: 'rlp',
    entityId: rlpId,
    severity: 'action_required',
    limit: 5,
  });
  const markRead = useMarkRead();
  const unresolved = (data?.notifications ?? []).filter(
    (n) => n.action_taken_at == null && n.dismissed_at == null
  );
  if (unresolved.length === 0) return null;
  const top = unresolved[0]!;

  const handleClick = () => {
    if (top.read_at == null) markRead.mutate(top.id);
  };

  return (
    <div
      role="status"
      className="card flex items-start gap-3 border-warn-border bg-warn-soft p-4"
      data-testid="rlp-action-banner"
    >
      <div className="mt-0.5 flex-shrink-0 rounded-full bg-warn/10 p-1.5 text-warn-bold">
        <AlertTriangle className="h-4 w-4" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[0.875rem] font-semibold text-warn-bold">{top.title}</div>
        {top.body && (
          <div className="mt-0.5 text-[0.8125rem] text-warn-bold/80 leading-snug">{top.body}</div>
        )}
        {unresolved.length > 1 && (
          <div className="mt-1 text-[0.75rem] text-warn-bold/70">
            +{unresolved.length - 1} more action{unresolved.length - 1 === 1 ? '' : 's'} for this
            RLP
          </div>
        )}
      </div>
      {top.link && (
        <a
          href={top.link}
          onClick={handleClick}
          className="flex-shrink-0 text-[0.8125rem] font-semibold text-warn-bold underline underline-offset-2 hover:text-warn-bold/80"
        >
          Open
        </a>
      )}
    </div>
  );
}
